import React from 'react';

import clsx from 'classnames';

export function Card({
  children,
  className,
  align,
  minHeight,
  padding,
  variant,
  ...props
}) {
  const cardClass = clsx(
    {
      'cdl-card': true,
      'cdl-card--flat': variant === 'flat',
      'cdl-card--overlay': variant === 'overlay',
      'cdl-card--suppressed': variant === 'suppressed',

      'cdl-card--padding-small': padding === 'small',
      'cdl-card--padding-large': padding === 'large',

      'cdl-card--align-bottom': align === 'bottom',
      'cdl-card--min-height': minHeight,
    },
    className
  );
  return (
    <div className={cardClass} {...props}>
      {children}
    </div>
  );
}
